import { View } from '@react-pdf/renderer';
import { Span } from '..';
import { en } from '../../theme/languages/en';
import { styles } from './NumericData.module';

interface NumericDataProps {
  name: string;
  amount: string;
  key?: string;
  isPartialPeriod?: boolean;
  amountStyle?: {};
  textStyle?: {};
  containerStyle?: {};
}

export const NumericData = ({
  name,
  amount,
  isPartialPeriod,
  amountStyle,
  textStyle,
  containerStyle,
}: NumericDataProps) => {
  return (
    <View style={[styles.container, containerStyle]} wrap={false}>
      <Span style={[styles.text, textStyle]}>{name}</Span>
      <Span canBeMissingValue missingValue={amount} style={[styles.text, amountStyle]}>
        {amount}
      </Span>
      {isPartialPeriod && (
        <View style={styles.partialTag}>
          <Span style={styles.partialInvoiceText}>{en.partial}</Span>
        </View>
      )}
    </View>
  );
};
